module.exports = __webpack_public_path__ + "static/media/blank-profile-picture.5a021ab9.png";